import { inject, injectable } from 'inversify';
import { ClientSeasonDependencyTypes } from '@client/entity/client-season/client-season.dependency-types';
import type { ClientSeasonService } from '@client/entity/client-season/domain/service/client-season.service';
import { MainLayoutDependencyTypes } from '@client/composition/main-layout/main-layout.dependency-types';
import type { MainLayoutStoreCommand } from '@client/composition/main-layout/domain/store/main-layout.store-command';
import type { CurrentClientUserClient } from '@client/entity/current-client-user/domain/model/current-client-user-client.model';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import type { CurrentClientUserStoreQuery } from '@client/entity/current-client-user/domain/store/current-client-user.store-query';

@injectable()
export class MainLayoutSubscriptionSubscriberProgressService {
  public constructor(
    @inject(ClientSeasonDependencyTypes.ClientSeasonService)
    private readonly clientSeasonService: ClientSeasonService,
    @inject(MainLayoutDependencyTypes.MainLayoutStoreCommand)
    private readonly mainLayoutStoreCommand: MainLayoutStoreCommand,
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserStoreQuery)
    private readonly currentClientUserStoreQuery: CurrentClientUserStoreQuery,
  ) {}

  public async loadSubscriptionSubscriberProgress(client: CurrentClientUserClient | null): Promise<void> {
    if (!client?.hasActiveSubscription) {
      this.mainLayoutStoreCommand.updateMainLayoutUiModel({
        subscriptionSubscriberProgress: null,
      });
      return;
    }

    this.mainLayoutStoreCommand.updateMainLayoutUiModel({
      subscriptionSubscriberProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        isLoading: true,
      },
    });

    try {
      const progress = await this.clientSeasonService.getSubscriberProgress(client.id);

      if (this.currentClientUserStoreQuery.getSelectedClientId() !== client.id) {
        return;
      }

      this.mainLayoutStoreCommand.updateMainLayoutUiModel({
        subscriptionSubscriberProgress: progress
          ? {
              ...progress,
              isLoading: false,
            }
          : null,
      });
    } catch {
      if (this.currentClientUserStoreQuery.getSelectedClientId() !== client.id) {
        return;
      }

      this.mainLayoutStoreCommand.updateMainLayoutUiModel({
        subscriptionSubscriberProgress: null,
      });
    }
  }
}
